import createImagePixelArray from './createImagePixelArray';
import createImageHistogramPalette from './createImageHistogramPalette';

import { rgbToHex } from '../../../../common/colors/colorSpaceUtil';
import globalLogger from '../../../logger';
import { fetchImageData } from '../../../element/image/imageFetchUtils';
import platformSingleton from '../../../platform/platformSingleton';
import { isPlatformCapacitor } from '../../../platform/utils/platformDetailsUtils';
import fetchImageDataFromUrl from './fetchImageDataFromUrl';

const logger = globalLogger.createChannel('images.color-palette');

const getColorPaletteFromUrl = async (url, imageType) => {
    try {
        const imageData = isPlatformCapacitor(platformSingleton)
            ? await fetchImageData(url, imageType)
            : await fetchImageDataFromUrl(url);

        const pixelCount = imageData.width * imageData.height;
        const pixelArray = createImagePixelArray(new Uint8Array(imageData.data), pixelCount, 20);
        const histogramPalette = createImageHistogramPalette(pixelArray);

        return histogramPalette.map(rgbToHex);
    } catch (error) {
        logger.error('Failed to extract image color palette', error);
        return [];
    }
};

export default getColorPaletteFromUrl;
